var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"id":"permission-changed","title":"Permission changed!","hide-header-close":"","ok-only":"","no-close-on-esc":"","no-close-on-backdrop":"","centered":"","cancel-disabled":""},on:{"ok":_vm.close}},[_vm._v(" Your permissions have been updated. You are about to be signed out. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }